import { useState } from "react";
import { useHistory } from "react-router-dom";
import useUrlState from "@ahooksjs/use-url-state";

import admins from "configs/admins";
import GenericHeader from "../../../components/GenericHeader/GenericHeader";
import GenericTable from "../../../components/GenericTable/GenericTable";

import Box from "@mui/material/Box";

import placeholderPic from "../../../assets/no_data_x.gif";
import { useApiHook } from "providers/ApiProvider";

const AdminsTableView = () => {
  const history = useHistory();

  const [selectedRows, setSelectedRows] = useState([]);
  const [queryParams, setQueryParams] = useUrlState({
    page: 0,
    size: 10,
    // sortBy: "id",
    // sortDirection: "desc",
  });

  const query = {
    page: Number(queryParams.page) + 1,
    size: queryParams.size,
    // sortBy: queryParams.sortBy ?? "id",
    // sortDirection: queryParams.sortDirection ?? "desc",
  };

  const adminData = useApiHook("Admins", "getAllResources", { query });

  const navigateToAddPage = () => {
    history.push(`admins/add`);
  };

  const rowTriggerAction = (row: any) => {
    history.push(`admins/${row?.id}`);
  };

  const handlePageChange = (e: any, value: any) => {
    setQueryParams({ page: value });
  };

  const handleRowsChange = (e: { target: { value: string } }) => {
    setQueryParams({ page: 0, size: parseInt(e.target.value) });
  };

  const handleRowSelectionChange = (data: any) => {
    setSelectedRows(data);
  };

  // const onColumnSort = (c: any) => {
  //   if (queryParams.sortBy === c) {
  //     setQueryParams((s) => ({
  //       sortDirection: s.sortDirection === "asc" ? "desc" : "asc",
  //     }));
  //   } else {
  //     setQueryParams({ sortBy: c, sortDirection: "asc" });
  //   }
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        maxHeight: "100vh",
        overflow: "scroll",
      }}
    >
      <GenericHeader
        addResourceHandler={navigateToAddPage}
        selectedRows={selectedRows}
        model="admin"
      />
      <div className="p-4">
        <h2 className="mb-4">Admins</h2>
        <GenericTable
          showCheckbox={false}
          frontendPagination={true}
          list={adminData?.data?.data ? adminData.data.data : []}
          totalCount={adminData?.data?.data?.length || 0}
          onSelectedChange={handleRowSelectionChange}
          selectedRows={selectedRows}
          page={Number(queryParams.page)}
          loading={adminData.loading}
          rowsPerPage={Number(queryParams.size)}
          onRowsChange={handleRowsChange}
          onPageChange={handlePageChange}
          image={placeholderPic}
          tableConfig={admins}
          model="admin"
          passRow={rowTriggerAction}
          // columnSort={queryParams.sortBy}
          // columnSortDir={queryParams.sortDirection}
          // onColumnSort={onColumnSort}
        />
      </div>
    </Box>
  );
};

export default AdminsTableView;
